import { useAtomValue } from 'jotai';
import { ScreenContainer } from 'smoothie';

import TransactionDetails from '../../../banking/components/spaces/transactions/TransactionDetails';
import useGetAccountDisplayDetailsFromGlobalState from '../../../banking/hooks/useGetAccountDisplayDetailsFromGlobalState';
import { selectedTransactionV2Atom } from '../../../banking/state/SpacesAtoms';

const TransactionDetailsScreen = () => {
    const selectedTransactionInfo = useAtomValue(selectedTransactionV2Atom);
    const { syncteraAccountId } = selectedTransactionInfo ?? {
        transaction: null,
        syncteraAccountId: '',
    };

    const { account } = useGetAccountDisplayDetailsFromGlobalState({
        syncteraAccountId,
    });

    return (
        <ScreenContainer title="Transaction details" hasBackButton>
            <TransactionDetails account={account} />
        </ScreenContainer>
    );
};

export default TransactionDetailsScreen;
